module.exports = __webpack_public_path__ + "static/media/videos-action-plan.00328f8f.svg";